module.exports = __webpack_public_path__ + "static/media/badge_preview.ccb5afbf.svg";